import { graphql } from '@teachino/shared-infrastructure';
import { topicFragment } from './topic.fragment';

export const coursesForTopicQuery = graphql(
  `
    query CoursesForTopic($topicId: String!) {
      topic(topicIdInput: { id: $topicId }) {
        ...Topic
      }
    }
  `,
  [topicFragment],
);
